<template>
  <div class="lv-dashboard-search-card">
    <WsText001
      h4
      bold
      class="mb-20"
    >
      {{ title }}
    </WsText001>
    <DurationDatePicker
      :value="date"
      :disable="isLoading"
      :scroll="scroll"
      class="lv-dashboard-search-card__date"
      @input="$_onInputCardParams($event, 'date')"
      @click="$_searchClick()"
    />
    <WsStateDropdownRadio001
      v-if="systemclass && systemclass.menuItems"
      v-model="systemclass.selectedMenuItem"
      outline
      :disabled="isLoading"
      :placeholder="systemclass.placeholder"
      :dropdownMenuItem="systemclass.menuItems"
      class="mt-10"
      @click="$_searchClick()"
    />
    <DotLoading v-if="isLoading" />
    <LlPaginateList
      v-if="page && !isLoading"
      :page-count="_page.lastPage"
      :page-range="3"
      :margin-pages="3"
      :first-button-text="_paginationFirstButtonText"
      :last-button-text="_paginationLastButtonText"
      :prev-text="_paginationPrevText"
      :next-text="_paginationNextText"
      :container-class="'pagination'"
      first-last-button
      :page="_page.ingPage"
      :from-data-num="_page.fromDataNum"
      :to-data-num="_page.toDataNum"
      :total-data-num="_page.totalDataNum"
      @input="$_paginatePage($event)"
    >
      <DataTable
        :column-header="dataTable.columnHeader"
        :row-data="dataTable.rowData"
        @data-click="$_dataClick($event)"
      />
    </LlPaginateList>
    <div
      v-if="isDisable"
      class="lv-diagram-card__disable"
    >
      <i
        class="lv-diagram-card__disable-icon"
        :class="disableIcon"
      />
      <div 
        class="lv-diagram-card__disable-text"
      >
        {{ $t(disableText) }}
      </div>
      <div 
        v-if="disableBtnText"
        class="lv-diagram-card__disable-btn"
      >
        <WsButton001
          width-stretch
          @click="$_disableClick()"
        >
          {{ $t(disableBtnText) }}
        </WsButton001>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    systemclass: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default: "",
    },
    date: {
      type: Object,
    },
    dataTable: {
      type: Object,
    },
    page: {
      type: Object,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    disableIcon: {
      type: String,
      default: "icon-lock",
    },
    disableText: {
      type: String,
      default: "",
    },
    disableBtnText: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    scroll: {
      type: Number,
    }
  },
  computed: {
    _paginationPrevText() {
      return '<i class="icon-chevron-back" />';
    },
    _paginationNextText() {
      return '<i class="icon-chevron-forward" />';
    },
    _paginationFirstButtonText() {
      return '<i class="icon-chevron-back-start" />';
    },
    _paginationLastButtonText() {
      return '<i class="icon-chevron-forward-end" />';
    },
    _allSystemClass() {
      if (!this.$store.state.model.systemClasses) {
        return [];
      } else {
        return this.$store.state.model.systemClasses;
      }
    },
    _page() {
      return this.page;
    },
  },
  watch: {
    _page: {
      immediate: true,
      deep: true,
      handler: function(newValue, oldValue) {
        if (newValue === oldValue || oldValue === undefined) return
        this.$_searchClick();
      },
    },
  },
  mounted() {
    this.systemSubclasses = this.$_setAllSystemClassesSelect();
  },
  methods: {
    $_setAllSystemClassesSelect() {
      let allSystem = [];
      this._allSystemClass.forEach((systemClass) => {
        systemClass.system_subclasses.forEach((subclass) => {
          allSystem.push(subclass.id);
        });
      });
      return allSystem;
    },
    $_searchClick() {
      if (this.isLoading) return;
      this.$emit("search-click");
    },
    $_dataClick($event) {
      this.$emit("data-click", $event);
    },
    $_paginatePage($event) {
      if (this._page.ingPage === $event) {
        return
      } else {
        const page = {...this.page, ingPage: $event}
        this.$emit("pagination-change", page)
      }
    },
    $_onInputCardParams($event, type) {
      this.$emit('input', {value: $event, type});
    }
  },
};
</script>